import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function DocumentIndexTermsComponent({ keywords, closeClick }) {
  return (
    <div className="result-detail-panel result-detail-index-terms">
      <div className="result-detail-panel-wrapper">
        <h4>Index Terms</h4>
        <div className="result-detail-panel typography-small">
          <div className="result-detail-block">
            {keywords.map((keyword) => (
              <div key={keyword.type}>
                <b>{keyword.type}: </b>
                {keyword.value &&
                  keyword.value.map((value) => (
                    <React.Fragment key={value}>
                      <InnerHTML tag="span" html={value} />
                      {keyword.value.indexOf(value) !== keyword.value.length - 1 && <span className="separator" />}
                    </React.Fragment>
                  ))}
              </div>
            ))}
          </div>
        </div>
        <a
          href="null"
          tabIndex="0"
          className="els-btn els-btn-modal-close e2e-close"
          onClick={(e) => {
            e.preventDefault();
            closeClick();
          }}>
          <svg className="els-btn-icon els-btn-icon-tiny">
            <use xlinkHref="#icon-delete" />
          </svg>
        </a>
      </div>
    </div>
  );
}

DocumentIndexTermsComponent.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentIndexTermsComponent;
